'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _coreAnimatedPages = require('./components/libcomponents/core-animated-pages.js');

var _coreAnimatedPages2 = _interopRequireDefault(_coreAnimatedPages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('./css/hero.scss');

var React = require('react');

var render = require('react-dom').render;

var AppResource = function (_React$Component) {
  _inherits(AppResource, _React$Component);

  function AppResource(props) {
    _classCallCheck(this, AppResource);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(AppResource).call(this, props));

    _this.state = {
      selected: 1,
      selectedsub: 1
    };
    return _this;
  }

  _createClass(AppResource, [{
    key: 'handleClick',
    value: function handleClick(page, subpage, e) {
      this.setState({
        selectedsub: subpage,
        selected: page
      });
    }
  }, {
    key: 'getPageStyle',
    value: function getPageStyle(flag) {
      return flag ? { opacity: "1", position: "relative", zIndex: "9999" } : { opacity: "0", position: "relative", zIndex: "1" };
    }

    /*<CoreAnimatedPages selected="1">
        <div label="1">
          <div className="circle" >
            <div data-heroid="thing" data-hero="hero" className="circleInner">
             </div>
          </div>
        </div>
        <div label="2">
          <div className="search" data-heroid="thing" data-hero="hero"><span>+</span><input type="text"/></div>
        </div>
      </CoreAnimatedPages>*/

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return React.createElement(
        'div',
        { className: 'heroApp' },
        React.createElement(
          _coreAnimatedPages2["default"],
          { selected: this.state.selected },
          React.createElement(
            'div',
            { label: '1', className: 'page1 squarewrap' },
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24].map(function (item, i) {
              return React.createElement(
                'div',
                { key: i, className: 'square', 'data-heroid': "thing" + item, 'data-hero': self.state.selectedsub == item ? "true" : "false", onClick: _this2.handleClick.bind(_this2, 1, item) },
                React.createElement(
                  'section',
                  null,
                  item
                )
              );
            })
          ),
          React.createElement(
            'div',
            { label: '2' },
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24].map(function (item, i) {
              return React.createElement(
                'div',
                { key: i, label: item, style: self.getPageStyle(self.state.selectedsub == item) },
                React.createElement(
                  'div',
                  { className: 'page', 'data-heroid': "thing" + item, 'data-hero': _this2.state.selectedsub == item ? "true" : "false" },
                  React.createElement(
                    'section',
                    null,
                    React.createElement(
                      'span',
                      { onClick: _this2.handleClick.bind(_this2, 2, item) },
                      'X'
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      { className: 'circle' },
                      '+'
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return AppResource;
}(React.Component);

window.uirender = function () {
  render(React.createElement(AppResource, null), document.getElementById('app'));
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hero.js
 ** module id = 93
 ** module chunks = 0
 **/